import { render } from "./CustomData.vue?vue&type=template&id=f5f8b744&scoped=true"
import script from "./CustomData.vue?vue&type=script&lang=js"
export * from "./CustomData.vue?vue&type=script&lang=js"

import "./CustomData.vue?vue&type=style&index=0&id=f5f8b744&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f5f8b744"]])

export default __exports__